'use client'

import {useHeaderStore} from '@local/stores/stores'
import {MutableRefObject, useEffect} from 'react'

const useBlock = (ref: MutableRefObject<HTMLElement>, isDark:boolean = false) => {
	const [addBlock, removeBlock] = useHeaderStore(state => [state.addBlock, state.removeBlock])

	useEffect(() => {
		const localRef = ref?.current
		if (localRef && isDark) {
			addBlock(localRef)

			return () => {
				removeBlock(localRef)
			}
		}
	}, [ref.current, addBlock, removeBlock, isDark])
}

export default useBlock
